import { render, staticRenderFns } from "./send-reset-password-email-page.vue?vue&type=template&id=08d1dd2c"
import script from "./send-reset-password-email-page.vue?vue&type=script&lang=js"
export * from "./send-reset-password-email-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports